import type { PublicSlotKey } from '#packages/apilib';
import type { SlotOpenerApi } from './publicApi';

export const SlotOpenerApiKey: PublicSlotKey<SlotOpenerApi> = {
  name: 'SlotOpenerApi',
  public: true,
};
